var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLlongSleeve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,101H4c-0.3,0-0.58-0.13-0.77-0.37c-0.19-0.23-0.27-0.54-0.21-0.83l16-80c0.09-0.44,0.45-0.76,0.9-0.8 c0.46-0.04,0.86,0.22,1.02,0.64l10,26c0.07,0.17,0.08,0.36,0.05,0.54l-10,54C20.9,100.66,20.48,101,20,101z M5.22,99h13.95 l9.8-52.9L20.3,23.58L5.22,99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116,101h-16c-0.48,0-0.9-0.34-0.98-0.82l-10-54C88.98,46,89,45.81,89.07,45.64l10-26 c0.16-0.41,0.57-0.67,1.02-0.64c0.44,0.04,0.81,0.36,0.9,0.8l16,80c0.06,0.29-0.02,0.6-0.21,0.83C116.58,100.87,116.3,101,116,101 z M100.83,99h13.95L99.7,23.58L91.04,46.1L100.83,99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,109H30c-0.55,0-1-0.45-1-1V46.19l-9.93-25.83c-0.18-0.48,0.03-1.02,0.49-1.25l16-8 c0.32-0.16,0.7-0.14,1,0.06L60,26.8l23.45-15.63c0.3-0.2,0.68-0.22,1-0.06l16,8c0.46,0.23,0.67,0.77,0.49,1.25L91,46.19V108 C91,108.55,90.55,109,90,109z M31,107h58V46c0-0.12,0.02-0.24,0.07-0.36l9.67-25.15l-14.67-7.33L60.55,28.83 c-0.34,0.22-0.77,0.22-1.11,0L35.93,13.15l-14.67,7.33l9.67,25.15C30.98,45.76,31,45.88,31,46V107z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlongSleeve);
export default __webpack_public_path__ + "static/media/llongSleeve.7c7613f59f1693e31b8d9ff8084fed83.svg";
export { ForwardRef as ReactComponent };